require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-planning-newsletter-management.json") })
        }
      }, "path---services-planning-newsletter-management");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-planning-newsletter-management!./.cache/json/services-planning-newsletter-management.json
// module id = 774
// module chunks = 231608221292675